import { createAsyncThunk } from '@reduxjs/toolkit';
import { ax } from 'services/apiService';


export const saveTicket = createAsyncThunk('save-ticket', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`service_request/save_tickets`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const getTicketInformation = createAsyncThunk('get-ticket-information', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`service_request/get_ticket_info`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});
export const saveTicketConversation = createAsyncThunk('save-ticket-conversation', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`service_request/saveticket_conversation`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getTicketConversation = createAsyncThunk('get-ticket-convo', async (payload: any, { rejectWithValue }) => {
    try {
        const { data } = await ax.post(`service_request/getticket_conversation_new`, payload);
        return data;
    } catch (error: any) {
        if (error.response && error.response.data) {
            return rejectWithValue(error.response.data);
        } else {
            return rejectWithValue(error.message);
        }
    }
});

export const getTicketHistory = createAsyncThunk('get-ticket-history', async (id: any) => {
    try {
        const { data } = await ax.get(`service_request/get_ticket/${id}`);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response;
        }
    }
});

export const getTicket = createAsyncThunk('get-ticket', async (id: any) => {
    try {
        const { data } = await ax.get(`service_request/get_ticket/${id}`);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response;
        }
    }
});

export const deleteTicket = createAsyncThunk('delete-ticket', async (id: any) => {
    try {
        const { data } = await ax.get(`service_request/delete_ticket/${id}`);
        return data;
    } catch (error) {
        if (error.response && error.response.data) {
            return error.response.data;
        } else {
            return error.response;
        }
    }
});
// export const getTicketConversation = createAsyncThunk('get-ticket-conversation', async (id: any) => {
//     try {
//         const { data } = await ax.get(`service_request/getticket_conversation_new/${id}`);
//         return data;
//     } catch (error) {
//         if (error.response && error.response.data) {
//             return error.response.data;
//         } else {
//             return error.response;
//         }
//     }
// });